<template>
    <Form ref="elFormObj" as="">
        <v-row density="compact">
            <v-col cols="6">
                <Field
                    name="bandSize"
                    label="Band Size"
                    v-slot="{ field, errors }"
                    v-model="bandSize"
                    :rules="{ required: !!cupSize }"
                >
                    <v-select
                        v-bind="field"
                        :model-value="field.value"
                        :error-messages="errors"
                        :items="braSizeBandItems"
                        name="bandSize"
                        label="Band Size"
                        hide-details
                        variant="outlined"
                        :required="!!cupSize"
                    ></v-select>
                </Field>
            </v-col>
            <v-col cols="6">
                <Field
                    name="cupSize"
                    label="Cup Size"
                    v-slot="{ field, errors }"
                    v-model="cupSize"
                    :rules="{ required: !!bandSize }"
                >
                    <v-select
                        v-bind="field"
                        :model-value="field.value"
                        :error-messages="errors"
                        :items="braSizeCupItems"
                        name="cupSize"
                        label="Cup Size"
                        variant="outlined"
                        :required="!!bandSize"
                        hide-details
                    ></v-select>
                </Field>
            </v-col>
        </v-row>
    </Form>
</template>

<script lang="ts" setup>
    import type { Field, Form } from 'vee-validate';
    import { isNil as lo_isNil } from 'es-toolkit';
    import { BraSizeBand, BraSizeCup } from '~/models';
    import { initVeeRules } from '~/helpers/forms';

    initVeeRules([ 'required' ]);

    const props = defineProps({
        modelValue: {
            type: String as PropType<Nilish<string>>,
            required: false,
            default: null
        },
        label: {
            type: String as PropType<string>,
            required: true
        }
    });

    const emit = defineEmits([
        'update:modelValue'
    ]);

    const isFormError = ref<boolean | undefined>(false);
    const elFormObj = shallowRef<typeof Form>();
    const bandSize = ref();
    const cupSize = ref();

    const braSizeBandItems = computed(() => [{ title: 'Band Size', value: null }, ...BraSizeBand]);
    const braSizeCupItems = computed(() => [{ title: 'Cup Size', value: null }, ...BraSizeCup]);

    const unWatchValue = watch([bandSize, cupSize], ([newValBand, newValCup]) => {
        const val = newValBand && newValCup ? `${newValBand}_${newValCup}` : null;
        isFormError.value = lo_isNil(val);
        emit('update:modelValue', val);
    });

    const unWatchModel = watch(() => props.modelValue, (val: string | unknown) => {
        const parts = String(val).split('_') ?? [];

        if (parts.length === 2) {
            const [newValBand, newValCup] = parts;
            bandSize.value = newValBand;
            cupSize.value = newValCup;
        }
    }, { immediate: true });

    onBeforeUnmount(() => {
        unWatchValue?.();
        unWatchModel?.();
    });
</script>

<style lang="scss" scoped>
.ethnicity-partial {
    button {
        font-size: 160%;
    }
}
</style>
